<template>
    <QuestionBaseQuiz :question="question" class="mt-1">
        <div>
            <FormLabel :value="$t('messages.answer')" :for="`answer_${question.question_id}`" />
            <!-- native modifier has been removed, please confirm whether the function has been affected  -->
            <FormInput
                id="title"
                v-model.number="answer.numerator"
                :name="`answer_${question.question_id}`"
                @keypress.enter.prevent
                :placeholder="$t('messages.numerator')"
                type="number"
                @wheel.passive="$event.target.blur()"
                step="1"
                class="mt-1 w-40"
            />

            <div class="mt-3 border-t-2 border-gray-300 w-40">
                <FormInput
                    id="title"
                    v-model.number="answer.denominator"
                    :name="`answer_${question.question_id}`"
                    @keypress.enter.prevent
                    :placeholder="$t('messages.denominator')"
                    type="number"
                    @wheel.passive="$event.target.blur()"
                    step="1"
                    class="mt-3 w-40"
                />
            </div>

            <div class="mt-1">
                <button @click="reset" :class="{ invisible: isEmpty }" class="text-gray-600" type="button">
                    <svg
                        class="w-6 h-6 inline-block"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                    {{ $t('messages.delete_answer') }}
                </button>
            </div>

            <AlertMessage class="mt-5 inline-block">
                <template v-slot:title>
                    {{ $t('messages.warning') }}
                </template>
                <template v-slot:body>
                    <span v-if="question.options.accepts_equivalent">
                        {{ $t('messages.accepts_equivalent_explanation') }}
                    </span>
                    <span v-else>
                        {{ $t('messages.does_not_accepts_equivalent_explanation') }}
                    </span>
                </template>
            </AlertMessage>
        </div>
    </QuestionBaseQuiz>
</template>

<script>
export default {
    name: 'QuestionMathFractionQuiz',
};
</script>
<script setup>
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import AlertMessage from '@/components/AlertMessage.vue';
import { computed, ref, watch } from 'vue';
import QuestionBaseQuiz from '@/components/Quiz/QuestionBaseQuiz.vue';

const props = defineProps({
    question: {
        required: true,
    },
    modelValue: {
        required: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const answer = ref(props.modelValue);

function reset() {
    answer.value = { numerator: '', denominator: '' };
}

const isEmpty = computed(() => {
    return answer.value.numerator === '' && answer.value.denominator === '';
});

const stringifiedAnswer = computed(() => {
    if (isEmpty.value) {
        return null;
    } else {
        return JSON.stringify(answer.value);
    }
});

watch(
    () => stringifiedAnswer.value,
    (newVal) => {
        emit('update:modelValue', newVal);
    },
    { immediate: true },
);
</script>
